<template>
  <button
    :style="style"
    :type="type"
    v-on="$listeners"
    v-bind="$attrs"
    class="text-sm font-bold uppercase border rounded lg:hover:opacity-75"
    :class="{ 'pointer-events-none opacity-50': $attrs.disabled }"
    :aria-disabled="$attrs.disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "button",
    },
  },
  computed: {
    style() {
      const colors = this.$store.state.config.colors;
      return {
        "--bg-color": colors.primaryButtonBackground || "#51B44F",
        "--border-color": colors.primaryButtonBorderColor || "#51B44F",
        "--color": colors.primaryButtonColor || "#FFFFFF",
      };
    },
  },
};
</script>

<style scoped>
button {
  background-color: var(--bg-color);
  border-color: var(--border-color);
  color: var(--color);
}
</style>
